import { render } from "./PdfCartaPropostaSemComponentes.vue?vue&type=template&id=5ad0e9f1&scoped=true"
import script from "./PdfCartaPropostaSemComponentes.vue?vue&type=script&lang=js"
export * from "./PdfCartaPropostaSemComponentes.vue?vue&type=script&lang=js"

import "./PdfCartaPropostaSemComponentes.vue?vue&type=style&index=0&id=5ad0e9f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad0e9f1"]])

export default __exports__